
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Customizedmobiltyplansforemploees() {



    const cardData =
    {
        keyword: 'Customized Mobility Plans for Employees Pune',
        heading: 'etravo : Customized Mobility Plans for Employees Pune',
        headingDescription: 'eTravo offers Customized Mobility Plans for Employees in Pune, designed to suit the unique transportation needs of businesses across sectors. Whether your team works fixed shifts, rotational hours, or requires last-mile connectivity, our tailored transport solutions ensure punctuality, safety, and comfort. We provide a wide range of GPS-enabled vehicles including sedans, SUVs, tempo travellers, and AC buses, all driven by experienced chauffeurs. With route optimization, flexible scheduling, and dedicated support, eTravo empowers companies in Pune to enhance employee satisfaction and operational efficiency through smart, adaptable transport plans.',

        top: 'Top Places to Visit in Pune with etravo',
         "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Built in 1732 as the seat of the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fortification in Pune. Though much of it was destroyed in an 1828 fire, the surviving structures and gardens offer a glimpse into its grand past. The site is renowned for its architectural features and is a popular tourist attraction."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Constructed in 1892 by Sultan Muhammed Shah Aga Khan III, this palace played a significant role during India's freedom movement. It served as a prison for Mahatma Gandhi and his wife Kasturba Gandhi during the Quit India Movement. The palace now houses a museum and memorials dedicated to Gandhi and his associates."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located approximately 28 km southwest of Pune, Sinhagad Fort is a hill fortress known for the Battle of Sinhagad in 1670. The fort offers panoramic views and is a popular destination for trekking enthusiasts. It houses memorials and remnants of historical significance."
    },
    {
      "title": "Dagdusheth Halwai Ganapati Temple",
      "description": "This renowned temple is dedicated to Lord Ganesha and is famous for its rich history and the grand idol adorned with gold. It attracts thousands of devotees, especially during the Ganesh Chaturthi festival."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, the Pataleshwar Cave Temple is carved from a single basalt rock. The temple complex includes a circular Nandi mandapa and is a protected monument under the Archaeological Survey of India."
    },
    {
      "title": "Osho International Meditation Resort",
      "description": "Situated in Koregaon Park, this meditation center offers a tranquil environment for spiritual growth and wellness. It attracts visitors worldwide seeking meditation and personal development programs."
    },
    {
      "title": "Pune Okayama Friendship Garden (Pu La Deshpande Garden)",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped garden symbolizes the Indo-Japanese friendship. It features manicured lawns, waterfalls, and a serene environment."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "This museum houses an extensive collection of artifacts showcasing India's rich cultural heritage. Exhibits include musical instruments, sculptures, and everyday objects from the 18th and 19th centuries."
    },
    {
      "title": "Koregaon Park",
      "description": "A vibrant neighborhood known for its lush greenery, upscale eateries, and cultural hubs. Koregaon Park is a popular destination for dining, shopping, and experiencing Pune's cosmopolitan lifestyle."
    },
    {
      "title": "Lal Mahal",
      "description": "Originally built in the 17th century, Lal Mahal is historically significant as the childhood residence of Chhatrapati Shivaji Maharaj. The reconstructed palace now serves as a museum showcasing Maratha history."
    }
  ],



"services": [
  {
    "name": "Customized Mobility Plans for Employees Pune",
    "description": "eTravo offers customized mobility plans for employees in Pune, tailoring routes, schedules, and vehicle types to perfectly match your workforce requirements and business hours."
  },
  {
    "name": "Tailored Commute Solutions Pune",
    "description": "Our tailored commute solutions in Pune provide flexible and scalable transport options designed specifically for your company’s staff, ensuring comfortable and timely travel."
  },
  {
    "name": "Personalized Corporate Transport Pune",
    "description": "eTravo delivers personalized corporate transport services in Pune, focusing on individual employee needs with dedicated vehicles and customized routes."
  },
  {
    "name": "Employee-Centric Mobility Packages Pune",
    "description": "We design employee-centric mobility packages in Pune that prioritize comfort, safety, and convenience, ensuring high staff satisfaction and reliable daily commutes."
  },
  {
    "name": "Staff Commute Planning Pune",
    "description": "Our expert staff commute planning services in Pune help businesses optimize routes, reduce travel times, and improve efficiency through data-driven scheduling."
  },
  {
    "name": "Custom Staff Transport Solutions Pune",
    "description": "Get custom staff transport solutions in Pune with eTravo that address your unique operational challenges, including shift changes, multiple locations, and special requirements."
  },
  {
    "name": "End-to-End Custom Mobility Pune",
    "description": "eTravo provides end-to-end custom mobility in Pune, managing everything from initial consultation to vehicle deployment and ongoing service adjustments."
  },
  {
    "name": "Employee Transport Plans Pune",
    "description": "Our employee transport plans in Pune offer flexible and affordable options, ensuring seamless travel solutions that adapt as your workforce evolves."
  },
  {
    "name": "Corporate Travel Customization Pune",
    "description": "Experience corporate travel customization in Pune with eTravo, where every aspect of employee transportation is tailored to meet your company’s specific needs."
  },
  {
    "name": "Executive Commute Programs Pune",
    "description": "Specialized executive commute programs in Pune by eTravo provide premium vehicle options and professional chauffeurs to ensure a smooth and comfortable travel experience."
  },
  {
    "name": "Monthly Tailored Transport Pune",
    "description": "Our monthly tailored transport services in Pune give you predictable costs and reliable, customized vehicle assignments for your staff throughout the month."
  },
  {
    "name": "Business-Specific Transport Services Pune",
    "description": "eTravo delivers business-specific transport services in Pune designed to meet the unique demands of various industries and operational models."
  },
  {
    "name": "Company-Specific Mobility Pune",
    "description": "Our company-specific mobility solutions in Pune provide customized routes, vehicles, and service levels aligned with your corporate culture and logistical needs."
  },
  {
    "name": "Reliable Custom Cab and Bus Hire Pune",
    "description": "Reliable custom cab and bus hire services in Pune by eTravo offer flexible contracts and well-maintained AC vehicles tailored to your company’s transport requirements."
  },
  {
    "name": "Staff Transport Design Pune",
    "description": "eTravo’s staff transport design in Pune includes detailed route mapping, schedule optimization, and vehicle allocation to create efficient and employee-friendly commute systems."
  }
],
"tableData": [
  ["Customized Mobility Plans for Employees Pune", "Tailored Commute Solutions Pune"],
  ["Personalized Corporate Transport Pune", "Employee-Centric Mobility Packages Pune"],
  ["Staff Commute Planning Pune", "Custom Staff Transport Solutions Pune"],
  ["End-to-End Custom Mobility Pune", "Employee Transport Plans Pune"],
  ["Corporate Travel Customization Pune", "Executive Commute Programs Pune"],
  ["Monthly Tailored Transport Pune", "Business-Specific Transport Services Pune"],
  ["Company-Specific Mobility Pune", "Reliable Custom Cab and Bus Hire Pune"],
  ["Staff Transport Design Pune", ""]
],




"whychoose": [
    {
        "WhyChooseheading": "Tailored Employee Mobility Plans in Pune",
        "WhyChoosedescription": "eTravo designs customized mobility solutions to perfectly fit your company’s unique workforce requirements across Pune, ensuring seamless and efficient employee transportation."
    },
    {
        "WhyChooseheading": "Flexible Fleet Options to Match Your Needs",
        "WhyChoosedescription": "Choose from our diverse fleet including hatchbacks, sedans, SUVs, tempo travellers, and AC buses—each vehicle type tailored to the size, route, and comfort preferences of your employees."
    },
    {
        "WhyChooseheading": "Adaptable Scheduling for Shift and Office Hours",
        "WhyChoosedescription": "Our mobility plans are designed to accommodate varied shift patterns and office timings, supporting businesses in Pune’s major hubs like Hinjewadi, Baner, and Magarpatta."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Local Route Knowledge",
        "WhyChoosedescription": "All drivers are background-verified, uniformed, and familiar with Pune’s key areas, ensuring timely pickups and safe, efficient commutes."
    },
    {
        "WhyChooseheading": "Cost-Effective and Transparent Pricing",
        "WhyChoosedescription": "Benefit from competitive pricing with no hidden fees, GST-compliant invoices, and billing structures that simplify expense management for your finance team."
    },
    {
        "WhyChooseheading": "Commitment to Safety and Hygiene",
        "WhyChoosedescription": "Regular vehicle sanitization, GPS tracking, seat belts, and onboard safety kits guarantee a secure and comfortable ride for all employees."
    },
    {
        "WhyChooseheading": "Real-Time Ride Monitoring and Support",
        "WhyChoosedescription": "Track rides live and access 24/7 customer support for instant assistance with route changes, emergencies, or last-minute requests."
    },
    {
        "WhyChooseheading": "Scalable Solutions for Growing Workforces",
        "WhyChoosedescription": "Whether your team is expanding or adapting to new shifts, our customized mobility plans scale seamlessly to meet your evolving employee transportation needs."
    }
]




















    }

const faqData = [
    [
        {
            question: 'Does eTravo offer customized mobility plans for employees in Pune?',
            answer: 'Yes, eTravo provides fully customized mobility plans in Pune tailored to company size, shift timings, route preferences, safety protocols, and employee convenience.',
        },
        {
            question: 'How does eTravo tailor transport plans for different employee needs?',
            answer: 'We analyze workforce distribution, shift patterns, and office locations to design optimized transport routes using a mix of vehicles — from hatchbacks to AC buses — ensuring coverage and efficiency.',
        },
        {
            question: 'Can companies in Pune modify transport plans as their operations change?',
            answer: 'Absolutely. eTravo offers dynamic plan adjustments to align with evolving workforce schedules, project expansions, or location changes — all managed through a dedicated support team.',
        },
        {
            question: 'What vehicle options are included in customized mobility plans?',
            answer: 'Our customized plans in Pune include hatchbacks, sedans, SUVs, tempo travellers, and AC buses (13–50 seaters), deployed based on route load, shift density, and comfort requirements.',
        },
        {
            question: 'Is there performance tracking for customized transport plans?',
            answer: 'Yes, clients receive regular reports including route adherence, driver logs, trip punctuality, and feedback summaries — all monitored and managed by an assigned account manager.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Harshal Joshi',
        designation: 'Admin Coordinator, Elenex Systems, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo created a customized mobility plan that perfectly fits our shift-based workforce. Their flexibility and attention to detail make them a standout transport partner in Pune.”',
    },
    {
        name: 'Ms. Shraddha More',
        designation: 'HR Lead, Axion Digital, Pune',
        rating: [1, 1, 1, 1, 1],
        text: '“We needed a solution that could scale with our growing team in Pune. eTravo delivered a mobility plan that’s both flexible and reliable — with great visibility into daily operations.”',
    },
];



















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Customized Mobility Plans for Employees Pune",
  "image": "https://www.etravo.in/images/keyword/customized-mobility-plans-pune.jpg",
  "description": "Customized employee mobility plans in Pune by eTravo. Tailored staff commute solutions including personalized transport packages, corporate travel customization, and flexible cab and bus hire services.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6009"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/customized-mobility-plans-for-employees-pune"
  }
};



    return (
        <div>
<Helmet>
  <title>Customized Mobility Plans for Employees Pune | Tailored Staff Transport Solutions | eTravo</title>
  <meta 
    name="description" 
    content="eTravo provides customized mobility plans for employees in Pune. Personalized staff transport packages, tailored corporate travel solutions, and company-specific cab and bus hire services." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/112.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Customizedmobiltyplansforemploees;